import { ensureFloat, ensureString } from '@/mixins/useEnsure'
import BrowserService from '@/services/browserService'

export default (user, userId, category, products) => {
  const items = products.map((item, index) => {
    return {
      id: ensureString(item.id),
      name: item.name,
      favorite: false,
      categories: [category.title],
      labels: item.properties.map((p) => {
        return p.name
      }),
      availability: item.state === 'available' ? 'stock' : 'supplier',
      price: ensureFloat(item.priceWithoutDiscountAndVat),
      discount: ensureFloat(item.discount) * -1,
      list_position: index + 1,
    }
  })

  const payload = {
    event: 'view_item_list',
    platform: BrowserService.platform(),
    sessionId: BrowserService.sessionId(),
    ecommerce: {
      currency: products[0].currencyCode,
      products: items,
      user: user,
    },
    _clear: true,
  }
  if (userId) payload.user_id = userId
  window.dataLayer?.push(payload)
}
